import { myListsDetailsPageStyles } from "@insite/content-library/Pages/MyListsDetailsPage";

import getColor from "@insite/mobius/utilities/getColor";
import { css } from "styled-components";

myListsDetailsPageStyles.inviteIsNotAvailableWrapper = {
    css: css`
        display: flex;
        height: 200px;
        justify-content: center;
        align-items: center;
        background-color: ${getColor("secondary")};
        font-family: "MontserratRegular";
    `,
};

myListsDetailsPageStyles.inviteIsNotAvailableText = {
    weight: "bold",
    css: css`
        font-family: "MontserratRegular";
    `,
};
